/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Einvoice_Delete_Old_DraftInputs */

const vi_einvoice_delete_old_draft = /** @type {(inputs: Einvoice_Delete_Old_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xoá nháp cũ trên MISA để không ai ký nhầm`)
};

/**

* @param {Einvoice_Delete_Old_DraftInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const einvoice_delete_old_draft = /** @type {((inputs?: Einvoice_Delete_Old_DraftInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Einvoice_Delete_Old_DraftInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_einvoice_delete_old_draft(inputs)
});